export default "__VITE_ASSET__gX3y1Tmk__"